import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3c40391e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "margin-b-standard" }
const _hoisted_2 = {
  key: 0,
  class: "start-message"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Click the "),
  /*#__PURE__*/_createElementVNode("strong", null, "Open editor"),
  /*#__PURE__*/_createTextVNode(" button to start authoring question.")
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "tools-buttons" }
const _hoisted_6 = {
  key: 0,
  class: "btn-3 disabled margin-r-standard"
}

import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";
import { computed, PropType } from "vue";
import { ContentStructureSection } from "@/models/content-structure.model";
import { mdiPencil } from "@mdi/js";
import { useUIContentStore } from "@/stores/ui-content.store";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionEditor',
  props: {
  section: {
    type: Object as PropType<ContentStructureSection>,
    required: true
  },
  isContentAuthoringTier2FeatureEnabled: {
    required: true,
    type: Boolean
  }
},
  setup(__props) {

const uiContentStore = useUIContentStore();

const props = __props;
const isStartMessageVisible = computed<boolean>(() => {
  return !!props.section && !props.section.document;
});

return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RightSidebarTitle, { title: 'Question Authoring' }),
    (isStartMessageVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (!__props.isContentAuthoringTier2FeatureEnabled)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
            _createVNode(_component_SVGIcon, {
              path: _unref(mdiPencil),
              size: 16
            }, null, 8, ["path"]),
            _createTextVNode(" Open editor ")
          ]))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            class: "btn-3 margin-r-standard",
            to: {
          name: 'question-editor',
          params: {
            productId: _unref(uiContentStore).sectionToDisplay.productId,
            sectionId: _unref(uiContentStore).sectionToDisplay.sectionId
          }
        }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SVGIcon, {
                path: _unref(mdiPencil),
                size: 16
              }, null, 8, ["path"]),
              _createTextVNode(" Open editor ")
            ]),
            _: 1
          }, 8, ["to"]))
    ])
  ]))
}
}

})